import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegistrationDto } from '@one-of-one/models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Reservation {
  private readonly _httpClient = inject(HttpClient);
  private readonly API_URL = `${environment.API_URL}/registrations`;

  createReservation(reserv: Partial<RegistrationDto>): Observable<string> {
    return this._httpClient.post<string>(this.API_URL, reserv);
  }

  getReservation(id: string): Observable<RegistrationDto> {
    return this._httpClient.get<RegistrationDto>(`${this.API_URL}/${id}`);
  }

  getQuote(id: string): Observable<Blob> {
    return this._httpClient.get(`${this.API_URL}/quote/${id}`, {
      responseType: 'blob',
    });
  }
}
